import { render, staticRenderFns } from "./CreatePricingForWrapped.vue?vue&type=template&id=fb3049a8&scoped=true"
import script from "./CreatePricingForWrapped.vue?vue&type=script&lang=js"
export * from "./CreatePricingForWrapped.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreatePricingForWrapped.vue?vue&type=style&index=1&id=fb3049a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3049a8",
  null
  
)

export default component.exports